<template>
  <FieldBox :title="$t('trade.expire-time')" class="time-in-force">
    <RadioBox v-model="timeInForce" :options="timeInForceTypes" />
  </FieldBox>
</template>
<script>
import { TIME_IN_FORCE } from 'const/trade'
import { mapGetters } from 'vuex'
import FieldBox from '../FieldBox'
import RadioBox from '../RadioBox'
const TIF_I18N_MAP = {
  [TIME_IN_FORCE.DAY]: 'trade.validity-rest-of-day',
  [TIME_IN_FORCE.GTC]: 'trade.validity-before-recall',
  [TIME_IN_FORCE.GTD]: 'trade.validity-before-date-specified'
}
export default {
  name: 'OrderTimeInForceField',
  components: { FieldBox, RadioBox },
  props: {
    addOrder: String, // profit / loss
    list: Array
  },
  computed: {
    ...mapGetters(['tradeRequest', 'isIb']),
    order() {
      return this.tradeRequest.order
    },
    stock() {
      return this.tradeRequest.stock
    },
    // 附加止盈单（即限价单）
    isAddPROFIT() {
      return this.addOrder === 'profit'
    },
    isAddLOSS() {
      return this.addOrder === 'loss'
    },
    timeInForceTypes() {
      return this.list.reduce((types, tif) => {
        if (TIF_I18N_MAP[tif]) {
          types.push({
            value: tif,
            label: this.$t(TIF_I18N_MAP[tif])
          })
        }
        return types
      }, [])
    },
    // 需要更新的字段名称
    tifKeyName() {
      if (this.isAddPROFIT) return 'profitTakerTif'
      if (this.isAddLOSS) return 'stopLossTif'
      return 'timeInForce'
    },
    timeInForce: {
      get() {
        return this.order[this.tifKeyName]
      },
      set(timeInForce) {
        this.$store.dispatch('updateTradeOrder', {
          [this.tifKeyName]: timeInForce
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .radio-box .radio-cell {
  max-width: 95px;
}
</style>
